"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profitInsightsAccumulator = void 0;
const utils_1 = __importDefault(require("../../utils"));
const profitInsightsAccumulator = (inputs) => {
    const { cohortTruncatedBaseDate, cohortTruncatedSeriesDate, cohortSeriesAge, } = inputs[0];
    let aggregateTotalExposure = 0;
    let aggregateChargedOffExposure = 0;
    let aggregateDelinquentExposure = 0;
    let aggregateTotalRepaid = 0;
    for (const input of inputs) {
        aggregateTotalExposure += input.totalExposure;
        aggregateChargedOffExposure += input.totalNormalizedIsChargedOffExposure;
        aggregateDelinquentExposure += input.totalNormalizedIsDelinquentExposure;
        if (aggregateTotalRepaid !== null) {
            if (input.totalRepaid !== null) {
                aggregateTotalRepaid += input.totalRepaid;
            }
            else {
                aggregateTotalRepaid = null;
            }
        }
    }
    return {
        cohortTruncatedBaseDate,
        cohortTruncatedSeriesDate,
        cohortSeriesAge,
        totalExposure: aggregateTotalExposure,
        totalNormalizedIsChargedOffExposure: aggregateChargedOffExposure,
        totalNormalizedIsDelinquentExposure: aggregateDelinquentExposure,
        chargedOffPercentageOfTotalExposure: utils_1.default.divideByOrZero(aggregateChargedOffExposure, aggregateTotalExposure),
        delinquentPercentageOfTotalExposure: utils_1.default.divideByOrZero(aggregateDelinquentExposure, aggregateTotalExposure),
        totalRepaid: aggregateTotalRepaid,
        percentageRepaidOfTotalExposure: aggregateTotalRepaid !== null
            ? utils_1.default.divideByOrZero(aggregateTotalRepaid, aggregateTotalExposure)
            : null,
    };
};
exports.profitInsightsAccumulator = profitInsightsAccumulator;
//# sourceMappingURL=accumulatorFn.js.map